import { Component, OnInit } from '@angular/core';

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
	title = 'Directia Mobilitate Urbană Sector 4';
	constructor() {
	}

	ngOnInit(): void {
	}

}
